function compareVersion(currentVersion, nextVersion) {
  if (!currentVersion || !nextVersion) {
    return null
  }

  const [prevMajor, prevMinor = 0, prevPatch = 0] = currentVersion.split('.').map(Number)
  const [curMajor, curMinor = 0, curPatch = 0] = nextVersion.split('.').map(Number)

  if (curMajor > prevMajor) {
    return 'major'
  }
  if (curMinor > prevMinor) {
    return 'feat'
  }
  if (curPatch > prevPatch) {
    return 'fix'
  }
  return null
}

export default compareVersion
